import ScreenReaderOnly from '../../accessibility/ScreenReaderOnly';
import styles from './progressBar.module.less';

const ProgressBar = ({
    percent,
    mini,
    matchingPercent = 0,
    matchingColor = '#002776',
    matchingGift = false,
    flat = false,
    className,
}) => {
    const totalPercent = percent < 0 ? 0 : percent;
    const displayTotalPercent = Math.max(0, Math.min(totalPercent, 100));
    const percentWithoutMatching = 100 - matchingPercent;

    const progressStyle = {
        width: `${percentWithoutMatching}%`,
    };

    const matchingGiftStyle = {
        backgroundColor: mini ? '#005AA4' : matchingColor,
        width: `${matchingPercent}%`,
    };

    const progressBars = matchingGift ? (
        <span className={styles.animatingBar}>
            <span style={matchingGiftStyle} className={styles.matchingGiftProgressBar} />
            <span style={progressStyle} className={styles.mainProgressBar} />
        </span>
    ) : (
        <span className={styles.animatingBar}>
            <span style={progressStyle} className={styles.progressBar} />
        </span>
    );

    return (
        <div className={[flat ? styles.flatWrapper : styles.classicWrapper, className].join(' ')}>
            <ScreenReaderOnly>{totalPercent}% av målet oppnådd</ScreenReaderOnly>

            <span className={styles.progressBarHolder} style={{ width: `${displayTotalPercent}%` }}>
                {progressBars}
            </span>
        </div>
    );
};

export default ProgressBar;
